var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionFavoriteAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.61 20.925 12 17.27V12h7.25l2.53-1.84a.532.532 0 0 0-.267-.961L14.81 8.63l-2.146-6.158a.704.704 0 0 0-1.329 0L9.19 8.63l-6.703.569a.532.532 0 0 0-.268.96L7.46 13.97l-1.516 6.498a.434.434 0 0 0 .666.457Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 14h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionFavoriteAdd);
export default __webpack_public_path__ + "static/media/ic_action_favorite_add.c695848760fbf6d156c46fe085d5014e.svg";
export { ForwardRef as ReactComponent };